import React from 'react';

const WeeklyDescription = () => {
    return (
        <div className="flex flex-row items-center w-full text-[13px] italic mt-[5px]">

            <div className="flex flex-row items-center mr-[1.5rem]">
                <div className="flex flex-row justify-center items-center bg-[#25c469] text-white font-bold w-6 h-6 rounded-[7px] mr-1">
                    <span className="-translate-y-[0.03rem]">-</span>
                </div>
                <span>Queda de ocorrências</span>
            </div>

            <div className="flex flex-row items-center">
                <div className="flex flex-row justify-center items-center bg-[#a8231b] text-white font-bold w-6 h-6 rounded-[5px] mr-1">
                    <span className="-translate-y-[0.05rem]">+</span>
                </div>
                <span>Aumento de ocorrências</span>
            </div>

            <div className="ml-auto flex flex-col text-[13px] font-bold italic text-right pr-[5px] text-[rgba(0,0,0,0.47)]">
                * 8 últimas semanas em relação à Data/hora final
            </div>

        </div>
    );
};

export default WeeklyDescription;